import {
    APP_BASE_HREF,
    DatePipe,
    HashLocationStrategy,
    LocationStrategy,
    PathLocationStrategy
} from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
//import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { UIRouterModule } from '@uirouter/angular';
import { environment } from '../environments/environment';
import { AccountModule } from './account/account.module';
import { AppComponent } from './app.component';
import { AppFooterComponent } from './app.footer.component';
import {
    AppDetailMenuComponent,
    AppMenuComponent,
    AppSubMenuComponent,
    AppMessageMenuComponent
} from './app.menu.component';
import { AppProfileComponent } from './app.profile.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AttachmentModule } from './attachment-view-feature/attachment.module';
import { SignInComponent } from './auth';
import { AuthInterceptor } from './auth/auth-interceptor';
import { AuthModule } from './auth/auth.module';
import { BurdenModule } from './burden/burden.module';
import { CheckupModule } from './checkup/checkup.module';
import { ClassModule } from './class/class.module';
import { ClassFeatureComponent } from './class/feature/class-feature.component';
import { ClassPresenterComponent } from './class/presenter/class-presenter.component';
import { CompanyCalendarModule } from './company-calendar/company-calendar.module';
import { CompanySettingModule } from './company-setting/company-setting.module';
import { ContractCumulativeModule } from './contract-cumulative/contract-cumulative.module';
import { ContractCumulativeFeatureComponent } from './contract-cumulative/feature/contract-cumulative-feature.component';
import { ContractCumulativePresenterComponent } from './contract-cumulative/presenter/contract-cumulative-presenter.component';
import { ContractManagementModule } from './contract-management/contract-management.module';
import { CustomerJobModule } from './contract-structure/contract-structure.module';
import { DashboardFeatureComponent } from './dashboard/dashboard-feature/dashboard-feature.component';
import { DashboardPresenterComponent } from './dashboard/dashboard-presenter/dashboard-presenter.component';
import { DashboardModule } from './dashboard/dashboard.module';
import * as fromDataServices from './data-services';
import { DataServicesModule } from './data-services/data-services.module';
import { DeferBillingFeatureComponent } from './defer-billing/defer-billing-feature/defer-billing-feature.component';
import { DeferBillingPresenterComponent } from './defer-billing/defer-billing-presenter/defer-billing-presenter.component';
import { DeferBillingModule } from './defer-billing/defer-billing.module';
import { EfaactConfigurationModule } from './efaact-configuration/efaact-configuration.module';
import { EfaactRoutingModule } from './efaact-routing/efaact-routing.module';
import { EmailAuditModule } from './email-audit/email-audit.module';
import { ExpenseItemModule } from './expense-item/expense-item.module';
import { ExpenseItemFeatureComponent } from './expense-item/feature/expense-item-feature.component';
import { ExpenseItemPresenterComponent } from './expense-item/presenter/expense-item-presenter.component';
import { ExpensesModule } from './expenses';
import { FeeLevelFeatureComponent } from './fee-level/feature/fee-level-feature.component';
import { FeeLevelModule } from './fee-level/fee-level.module';
import { FeeLevelPresenterComponent } from './fee-level/presenter/fee-level-presenter.component';
import { FixedPriceModule } from './fixed-price/fixed-price.module';
import { GroupsModule } from './groups/groups.module';
import { HelpDeskModule } from './help-desk/help-desk.module';
import { IndirectJobsModule } from './indirect-jobs/indirect-jobs.module';
import { IndirectRateModule } from './indirect-rate/indirect-rate.module';
import { InvoiceModule } from './invoice/invoice.module';
import { JobAuditModule } from './job-audit/job-audit.module';
import { LeaveAdjustmentModule } from './leave-adjustment/leave-adjustment.module';
import { LeaveRequestModule } from './leave-request/leave-request.module';
import { LogoModule } from './logo/logo.module';
import { LookupsModule } from './lookups/lookups.module';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { MainComponent } from './main/main.component';
import { ManageUsersModule } from './manage-users/manage-users.module';
import { ManualAdjustmentFeatureComponent } from './manual-adjustment/manual-adjustment-feature/manual-adjustment-feature.component';
import { ManualAdjustmentPresenterComponent } from './manual-adjustment/manual-adjustment-presenter/manual-adjustment-presenter.component';
import { ManualAdjustmentModule } from './manual-adjustment/manual-adjustment.module';
import { MemberComponent } from './member/member.component';
import { OversignTimeModule } from './oversign-time/oversign-time.module';
import { PayrateOverrideModule } from './payrate-override/payrate-override.module';
import { PayrollModule } from './payroll/payroll.module';
import { PremiumPayModule } from './premium-pay/premium-pay.module';
import { ProjectBudgetModule } from './project-budget/project-budget.module';
import { AssignmentPresenterComponent } from './pto-policy/assignment-presenter/assignment-presenter.component';
import { PtoPolicyFeatureComponent } from './pto-policy/pto-policy-feature/pto-policy-feature.component';
import { PtoPolicyPresenterComponent } from './pto-policy/pto-policy-presenter/pto-policy-presenter.component';
import { PtoPolicyModule } from './pto-policy/pto-policy.module';
import { SetupPresenterComponent } from './pto-policy/setup-presenter/setup-presenter.component';
import { QuickAccessComponent } from './quick-access/quick-access.component';
import { QuickbooksModule } from './quickbooks/quickbooks.module';
import { RateCeilingFeatureComponent } from './rate-ceiling/rate-ceiling-feature/rate-ceiling-feature.component';
import { RateCeilingPresenterComponent } from './rate-ceiling/rate-ceiling-presenter/rate-ceiling-presenter.component';
import { RateCeilingModule } from './rate-ceiling/rate-ceiling.module';
import { RecalculateTransactionsModule } from './recalculate-transactions/recalculate-transactions.module';
import { ReconciliationModule } from './reconciliation/reconciliation.module';
import { ReminderModule } from './reminder/reminder.module';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportComponent } from './report/report.component';
import { ReportingModule } from './reporting/reporting.module';
import { RowsPerPageModule } from './rows-per-page/rows-per-page.module';
import { ServiceItemModule } from './service-item/service-item.module';
import { DialogService } from './shared/efaact-primeng.module';
import { PUTInterceptor } from './shared/put-interceptor';
import { SharedModule } from './shared/shared.module';
import { EfaactEffects } from './store/effects';
import * as fromRoot from './store/reducers';
import { metaReducers } from './store/reducers';
import { ThemeToggleComponent } from './theme-toggle/theme-toggle.component';
import { TimeCardModule } from './timecard/time-card.module';
import { EFToasterModule } from './toaster/toaster.module';
import { UserAuthorizationsModule } from './user-authorizations/user-authorizations.module';
import { UserInfoComponent } from './user-info/user-info.component';
import { UserInfoModule } from './user-info/user-info.module';
import { UserRoleComponent } from './user-role/user-role.component';
import { UserRoleModule } from './user-role/user-role.module';
import { UserSelectorModule } from './user-selector/user-selector.module';
import { UserSettingModule } from './user-setting/user-setting.module';
import { UserEntryDatesModule } from './userentrydates/userentrydates.module';
import { RatePlanningModule } from './rate-planning/rate-planning.module';
import { RatePlanningPresenterComponent } from './rate-planning/rate-planning-presenter/rate-planning-presenter.component';
import { RatePlanningFeatureComponent } from './rate-planning/rate-planning-feature/rate-planning-feature.component';
import { RegistrationModule } from './registration';
import { ImportModule } from './import/import.module';
import { VendorModule } from './vendor/vendor.module';
import { AuthorizenetCheckoutPresenterComponent } from './authorizenet-checkout/authorizenet-checkout-presenter/authorizenet-checkout-presenter.component';
import { AuthorizenetCheckoutFeatureComponent } from './authorizenet-checkout/authorizenet-checkout-feature/authorizenet-checkout-feature.component';
import { AuthorizenetSubscriptionsDialogComponent } from './authorizenet-checkout/authorizenet-subscriptions-dialog/authorizenet-subscriptions-dialog.component';
import { AuthorizeNetCheckoutModule } from './authorizenet-checkout/authorizenet-checkout.module';
import { MergePresenterComponent } from './merge/merge-presenter/merge-presenter.component';
import { MergeFeatureComponent } from './merge/merge-feature/merge-feature.component';
import { MergeModule } from './merge/merge.module';
import { TaskTimerPresenterComponent } from './task-timer/task-timer-presenter/task-timer-presenter.component';
import { TaskTimerModule } from './task-timer/task-timer.module';
import { TaskTimerFeatureComponent } from './task-timer/task-timer-feature/task-timer-feature.component';
import { CustomerAdminPresenterComponent } from './customer-admin/customer-admin-presenter/customer-admin-presenter.component';
import { CustomerAdminFeatureComponent } from './customer-admin/customer-admin-feature/customer-admin-feature.component';
import { CustomerAdminModule } from './customer-admin/customer-admin.module';
import { InternalAdminPresenterComponent } from './internal-admin/internal-admin-presenter/internal-admin-presenter.component';
import { InternalAdminFeatureComponent } from './internal-admin/internal-admin-feature/internal-admin-feature.component';
import { InternalAdminModule } from './internal-admin/internal-admin.module';
import { AboutModule } from './about/about.module';
import { EmployeeValidationModule } from './employee-validation/employee-validation.module';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { MessageService } from 'primeng/api';
import { AppLayout } from './layout/components/app.layout';
import { PasswordChangeModule } from './password-change/password-change.module';
import { PasswordChangeFeatureComponent } from './password-change/password-change-feature/password-change-feature.component';
import { PasswordChangePresenterComponent } from './password-change/password-change-presenter/password-change-presenter.component';
import { ChatModule } from './aichat/chat.module';
@NgModule({
    declarations: [
        AppComponent,
        MainMenuComponent,
        UserInfoComponent,
        ReportComponent,
        ReportListComponent,
        MemberComponent,
        SignInComponent,
        MainComponent,
        QuickAccessComponent,
        UserRoleComponent,
        ThemeToggleComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        AppDetailMenuComponent,
        AppMessageMenuComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppProfileComponent,
        ContractCumulativePresenterComponent,
        ContractCumulativeFeatureComponent,
        ExpenseItemPresenterComponent,
        ExpenseItemFeatureComponent,
        ClassPresenterComponent,
        ClassFeatureComponent,
        FeeLevelPresenterComponent,
        FeeLevelFeatureComponent,
        ManualAdjustmentPresenterComponent,
        ManualAdjustmentFeatureComponent,
        DeferBillingPresenterComponent,
        DeferBillingFeatureComponent,
        PtoPolicyFeatureComponent,
        PtoPolicyPresenterComponent,
        SetupPresenterComponent,
        AssignmentPresenterComponent,
        RateCeilingPresenterComponent,
        RateCeilingFeatureComponent,
        DashboardPresenterComponent,
        DashboardFeatureComponent,
        RatePlanningPresenterComponent,
        RatePlanningFeatureComponent,
        AuthorizenetCheckoutPresenterComponent,
        AuthorizenetCheckoutFeatureComponent,
        AuthorizenetSubscriptionsDialogComponent,
        MergePresenterComponent,
        MergeFeatureComponent,
        TaskTimerPresenterComponent,
        TaskTimerFeatureComponent,
        CustomerAdminPresenterComponent,
        CustomerAdminFeatureComponent,
        InternalAdminPresenterComponent,
        InternalAdminFeatureComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        AppLayout,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        UIRouterModule,
        StoreModule.forRoot(fromRoot.reducers, { metaReducers }),
        EffectsModule.forRoot([EfaactEffects]),
        StoreDevtoolsModule.instrument({
            name: 'eFAACT Central',
            maxAge: 100,
            logOnly: environment.production
        }),
        AuthorizeNetCheckoutModule,
        DataServicesModule,
        EfaactRoutingModule,
        EfaactConfigurationModule,
        SharedModule,
        MatBadgeModule,
        //MatTooltipModule,
        MatBadgeModule,
        //MatTooltipModule,
        // Efaact modules below here
        RowsPerPageModule,
        LookupsModule,
        AuthModule,
        UserSelectorModule,
        UserAuthorizationsModule,
        UserInfoModule,
        UserRoleModule,
        ExpensesModule,
        ExpenseItemModule,
        FixedPriceModule,
        GroupsModule,
        UserEntryDatesModule,
        CustomerJobModule,
        ContractManagementModule,
        ContractCumulativeModule,
        IndirectJobsModule,
        LeaveRequestModule,
        HelpDeskModule,
        CompanySettingModule,
        CheckupModule,
        ManageUsersModule,
        TimeCardModule,
        ReportingModule,
        UserSettingModule,
        LogoModule,
        PayrollModule,
        ServiceItemModule,
        ReminderModule,
        OversignTimeModule,
        AccountModule,
        AttachmentModule,
        IndirectRateModule,
        LeaveAdjustmentModule,
        InvoiceModule,
        PremiumPayModule,
        PayrateOverrideModule,
        ClassModule,
        ProjectBudgetModule,
        FeeLevelModule,
        ReconciliationModule,
        RegistrationModule,
        CompanyCalendarModule,
        ManualAdjustmentModule,
        RecalculateTransactionsModule,
        DeferBillingModule,
        PtoPolicyModule,
        EmailAuditModule,
        BurdenModule,
        JobAuditModule,
        RateCeilingModule,
        DashboardModule,
        EFToasterModule,
        QuickbooksModule,
        RatePlanningModule,
        ImportModule,
        VendorModule,
        MergeModule,
        TaskTimerModule,
        CustomerAdminModule,
        InternalAdminModule,
        AboutModule,
        EmployeeValidationModule,
        PasswordChangeModule,
        ChatModule
    ],
    providers: [
        DatePipe,
        ErrorHandler,
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: fromDataServices.Invoice.Setup.Invoice.InvoiceSetupInterceptor,
            multi: true
        }, // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: LoadingInterceptor,
        //     multi: true
        // },
        { provide: HTTP_INTERCEPTORS, useClass: PUTInterceptor, multi: true },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        // this doesn't match <base href='/'> in index.html b/c assets and stuff are stored relative to the base href, NOT APP_BASE_HREF,
        // APP_BASE_HREF is used for the location strategy for the angular pages -->
        { provide: APP_BASE_HREF, useValue: '/efc' },
        DialogService,
        MessageService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
